import { API, axiosInstance } from "lib";

export const getGuest = (data,filter) => {
    return axiosInstance
    .get(data?`${data}`:`${API.GUEST}?${filter}`, {})
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };

  export const createGuest = (data = {}) => {
    return axiosInstance
      .post(API.GUEST, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };

  export const deleteGuest = (data = {}) => {
    return axiosInstance
      .delete(`${API.GUEST}/${data?.id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };
  
  
  export const getSingleGuest = (data = {}) => {
    return axiosInstance
      .get(`${API.GUEST}/${data}`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };

  export const getSingleGuestMobile = (filters) => {
    const queryParams = new URLSearchParams(filters).toString();
    return axiosInstance
    .get(`${API.GUEST}?${queryParams}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };
  
  export const updateGuest = (data = {}) => {
    return axiosInstance
      .patch(`${API.GUEST}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };
  
  export const changeGuestStatus = (data = {}) => {
    return axiosInstance
      .patch(`${API.GUEST}/${data?.id}`, data.payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };

  export const checkWhatsapp = (data = {}) => {
    return axiosInstance
      .post(API.CHECKWAPP, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error
    });
  };

  export const checkRoom = (data = {}) => {
    return axiosInstance
      .get(`${API.CHECKROOM}?room_number=${data}`, data)
      .then((response) => {
       
        return response.data;
       
      })
      .catch((error) => {
        console.log("eeee",error)
        return error
       
    });
  };
  